import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
  baseURL: process.env.VUE_APP_baseUrl,
})

axiosIns.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      const existingAuth = config?.headers?.Authorization || config?.headers?.authorization
      if (existingAuth) return config
      return {
        ...config,
        headers: {
          ...(config.headers || {}),
          Authorization: `Token ${token}`,
        },
      }
    }
    return config
  },
  error => Promise.reject(error),
)

Vue.prototype.$http = axiosIns

export default axiosIns
